import React from "react";
import classnames from "classnames";
import { FmIcon } from "../FmIcon";
import IconButton from "@mui/material/IconButton";
import { useTheme } from "../../Hooks";
import useStyles from "./FmIconButton.style";

declare type IconButtonVariant = "backArrow" | "hamburger";

interface FmIconButtonProps {
    onClick?: () => void;
    className?: string;
    variant?: IconButtonVariant;
}

const FmIconButton = ({ onClick, className, variant = "hamburger" }: FmIconButtonProps) => {
    const classes = useStyles();
    const theme = useTheme();
    const containerClass = classnames(classes.container, className);

    const iconClass = classnames({
        [classes.hamburgerIcon]: variant === "hamburger",
        [classes.backArrow]: variant === "backArrow",
        [classes.backArrowReverse]: variant === "backArrow" && theme.direction === "rtl",
    });

    const imagUrl = variant === "hamburger" ? theme.images.hamburger : variant === "backArrow" ? theme.images.leftArrow : "";

    return (
        <IconButton className={containerClass} onClick={onClick}>
            <FmIcon className={iconClass} url={imagUrl} title={variant} />
        </IconButton>
    );
};

export default FmIconButton;
